<template>
  <div class="aboutNX">
    <div
      class="banner"
      :style="`background-image:url(${banner.picUrl})`"
      @click="goBannerUrl"
      :class="{canClick: banner.connection}"
    >
      <h1>用互联网改变农业，打造智慧养殖新模式</h1>
    </div>
    <div class="middle-content">
      <section>
        <ul class="company-tab">
          <li class="right-line" :class="{'active-li':tabName==='company'}" @click="handelTab('company')">
            <div class="short-line"></div>
            <i class="company"></i>
            <p>公司简介</p>
          </li>
          <li class="right-line" :class="{'active-li':tabName==='framework'}" @click="handelTab('framework')">
            <div class="short-line"></div>
            <i class="framework"></i>
            <p>企业架构</p>
          </li>
          <li class="right-line" :class="{'active-li':tabName==='history'}" @click="handelTab('history')">
            <div class="short-line"></div>
            <i class="history"></i>
            <p>发展大事件</p>
          </li>
          <li class="right-line" :class="{'active-li':tabName==='honor'}" @click="handelTab('honor')">
            <div class="short-line"></div>
            <i class="honor"></i>
            <p>荣誉资质</p>
          </li>
          <li :class="{'active-li':tabName==='man'}" @click="handelTab('man')">
            <i class="man"></i>
            <p>合作伙伴</p>
          </li>
        </ul>
      </section>

      <div v-for="(item, index) in introList" :key="index">
      <section v-if="tabName==='company' && item.type === '0'">
        <h1>{{item.labelName}}</h1>
        <div class="text-retract" v-html="item.content"></div>
      </section>

      <!-- <section class="partner" v-if="growList.length>0">
        <h1>成长伙伴</h1>
        <div class="grow-partner">
          <div class="person"  v-for="(item,key) in growList" :key="key">
            <div class="pic" :style="`background-image:url(${item.pictureUrl})`"></div>
            <div class="content">
              <p class="name">{{item.employeeName}}</p>
              <p class="title">{{item.title}}</p>
            </div>
          </div>
        </div>
        <div class="test"></div>
      </section>-->

      <section v-if="tabName==='framework' && item.type === '1'">
        <h1>{{item.labelName}}</h1>
        <div class="text-retract" v-html="item.content"></div>
      </section>
      </div>

      <section v-if="tabName==='honor'">
        <h1>荣誉资质</h1>
        <div class="honor">
          <div class="box" v-for="(item,key) in honorList" :key="key">
            <div class="pic" :style="`background-image:url(${item.pictureUrl})`"></div>
            <p>{{item.honorName}}</p>
          </div>
        </div>
      </section>

      <section class="partner" v-if="tabName==='man'">
        <h1>合作伙伴</h1>
        <div class="partner-logo">
          <div class="logo" v-for="(item,key) in partnerList" :key="key">
            <i :style="`background-image:url(${item.pictureUrl})`"></i>
          </div>
        </div>
        <div class="test"></div>
      </section>

      <section v-if="tabName==='history'">
        <h1>发展大事件</h1>
        <div class="big-thing">
          <div class="content">
            <div class="shade left"></div>
            <div class="dev-list">
              <scroll-pane ref="scrollPane" class="tags-view-wrapper">
                <div class="p200"></div>
                <div
                  class="dev-box"
                  v-for="(item,key) in devList"
                  :key="key"
                  :class="{last:key === devList.length -1}"
                >
                  <div class="circle"></div>
                  <p class="year">{{item.year}}</p>
                  <p class="mon">{{item.mon}}</p>
                  <p class="text">{{item.content}}</p>
                </div>
              </scroll-pane>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import { getSession, setSession } from '@/utils/index'
import ScrollPane from './components/ScrollPane'
export default {
  name: 'companyIntro',
  components: { ScrollPane },
  data () {
    return {
      x1: 0,
      move_x: 0,
      banner: {
        picUrl:
          'https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg'
      },
      honorList: [],
      devList: [
        {
          content: '荣获“2019中国农牧业风云榜年度智慧养猪服务商”称号',
          year: '2019',
          mon: '12月'
        },
        {
          content: '受邀参与“2019厦门新经济发展大会”',
          year: '2019',
          mon: '11月'
        },
        {
          content: '亮相李曼养猪大会暨2019世界猪业博览会',
          year: '2019',
          mon: '10月'
        },
        { content: '参与2019iOTF物联中国年度盛典', year: '2019', mon: '7月' },
        {
          content: '2019世界移动大会荣获智慧农业先锋奖',
          year: '2019',
          mon: '6月'
        },
        {
          content: '召开2019猪友节并亮相第十届中国畜博会',
          year: '2019',
          mon: '5月'
        },
        {
          content: '厦门农芯数字科技有限公司正式成立',
          year: '2019',
          mon: '4月'
        },
        {
          content: '上榜中国独角兽榜单，估值11.38亿美元',
          year: '2019',
          mon: '2月'
        },
        { content: ' 农信平台累计交易额突破1000亿', year: '2018', mon: '6月' },
        {
          content: '“生猪市场（交易）价格指数”正式发布',
          year: '2017',
          mon: '5月'
        },
        { content: '“企联网”平台框架及系列产品发布', year: '2016', mon: '4月' },
        {
          content: '设立重庆生猪交易有限公司，建设国家级生猪交易市场',
          year: '2015',
          mon: '12月'
        },
        {
          content: '“猪联网”正式发布，助推养猪产业转型升级',
          year: '2015',
          mon: '5月'
        }
      ],
      partnerList: [],
      growList: [],
      tabName: 'company',
      introList: []
    }
  },
  mounted () {
    if (!getSession('bannerPic')) {
      this.getBannerPage()
    } else {
      this.banner = getSession('bannerPic').company_introduction
    }

    this.getCoopPartnerPage()
    this.getGrowthPartnerPage()
    this.getHonorrPage()
    this.getComProfilePage()
    this.$scroll.reveal('.banner h1', {
      distance: '50px',
      origin: 'left',
      duration: 1000
    })
  },
  methods: {
    handelTab (name) {
      this.tabName = name
    },
    /**
     * 获取 banner 图片
     */
    async getBannerPage () {
      const params = {
        currentPage: 1,
        pageSize: 100
      }
      const res = (await this.API.basic.getBannerPage(params)) || []
      // eslint-disable-next-line prefer-const
      let arr = {}
      res.data.map(o => {
        this.$set(arr, o.remark, {
          picUrl: o.pictureUrl,
          connection: o.connection
        })
      })
      this.banner = arr.company_introduction
      setSession('bannerPic', arr)
    },
    /** 荣誉列表 */
    async getHonorrPage () {
      const params = {
        currentPage: 1,
        pageSize: 100,
        sortRule: 0
      }
      const res = await this.API.recruit.getHonorrPage(params)
      this.honorList = res.data || []
    },
    /** 合作伙伴 */
    async getCoopPartnerPage () {
      const params = {
        currentPage: 1,
        pageSize: 100,
        sortRule: 0
      }
      const res = await this.API.recruit.getCoopPartnerPage(params)
      this.partnerList = res.data || []
    },
    /** 成长伙伴 */
    async getGrowthPartnerPage () {
      const params = {
        currentPage: 1,
        pageSize: 100,
        sortRule: 0
      }
      const res = await this.API.recruit.getGrowthPartnerPage(params)
      this.growList = res.data || []
    },
    /** 跳转banner配置连接 */
    goBannerUrl () {
      if (!this.banner.connection) {
        return ''
      }
      window.open(this.banner.connection)
    },
    /* 农芯介绍列表分页 */
    async getComProfilePage () {
      const params = {
        currentPage: 1,
        pageSize: 100
      }
      const res = await this.API.recruit.getComProfilePage(params)
      for (let i = 0; i < res.data.length; i++) {
        if (res.data[i].state === 0) {
          this.introList.push(res.data[i])
        }
      }
    }
  }
}
</script>
<style lang="less">
//reset element css of el-icon-close
.tags-view-wrapper {
  .tags-view-item {
    .el-icon-close {
      width: 16px;
      height: 16px;
      vertical-align: 2px;
      border-radius: 50%;
      text-align: center;
      transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
      transform-origin: 100% 50%;
      &:before {
        transform: scale(0.6);
        display: inline-block;
        vertical-align: -3px;
      }
      &:hover {
        background-color: #b4bccc;
        color: #fff;
      }
    }
  }
}
</style>
